module.exports = __webpack_public_path__ + "static/ggif-b9b84467d104a8c12f92eafdb418425c.png";